<template>
  <v-form @submit.prevent>
    <tiles-form :tile="doc" />
    <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import TilesForm from "./Form";
import router from "@/router";

export default {
  name: "AdminBenchmarkAdd",
  components: {
    TilesForm,
  },
  data() {
    return {
      doc: {},
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      let ref = this.$parent.collection.doc();
      ref
        .set({
          createdOn: new Date(),
          id: ref.id,
          title: this.populateField(this.doc.title),
          visionTitle: this.populateField(this.doc.visionTitle),
          vision: this.populateField(this.doc.vision),
          socialTitle: this.populateField(this.doc.socialTitle),
          social: this.populateField(this.doc.social),
          collectionsTitle: this.populateField(this.doc.collectionsTitle),
          collections: this.populateField(this.doc.collections),
          matrix: this.populateField(this.doc.matrix),
          src: this.populateField(this.doc.src),
        })
        .then(() => {
          router.push({ name: this.$parent.returnRoute });
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    populateField(field) {
      return field ? field : null;
    },
  },
};
</script>
